document.addEventListener("DOMContentLoaded", function () {
  const productHandle = window.location.pathname.split("/products/")[1];
  const container = document.getElementById("recently-viewed-products");

  // Load and display recently viewed products (excluding current one)
  if (container) {
    let viewed = JSON.parse(localStorage.getItem("recently_viewed")) || [];

    const filteredViewed = viewed.filter(h => h !== productHandle);
    const limitedViewed = filteredViewed.slice(0, 4); // Max 4 products

    limitedViewed.forEach(handle => {
      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          const html = `
            <div class="grid__item">
              <div class="card-wrapper underline-links-hover">
                <div class="card card--standard card--media color-background-2 gradient">
                  <a href="${product.url}" class="card__inner ratio" style="--ratio-percent: 100%;">
                    <img src="${product.images[0]}" alt="${product.title}" class="motion-reduce recently-viewed-img" loading="lazy" />
                  </a>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading h5">
                        <a href="${product.url}" class="full-unstyled-link">
                          ${product.title}
                        </a>
                      </h3>
                      <span class="price price--end">
                        <span class="price-item price-item--regular">
                          $${(product.price / 100).toFixed(2)}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `;
          container.insertAdjacentHTML("beforeend", html);
        });
    });
  }

  // After displaying, now save the current product
  if (productHandle) {
    let viewed = JSON.parse(localStorage.getItem("recently_viewed")) || [];

    // Remove existing instance if already in list
    viewed = viewed.filter(h => h !== productHandle);

    // Add current product to the front
    viewed.unshift(productHandle);

    // Limit stored history to 5 max
    if (viewed.length > 5) viewed = viewed.slice(0, 5);

    localStorage.setItem("recently_viewed", JSON.stringify(viewed));
  }
});

